export enum VendorSmartMicroAppName {
  InvoiceDetails = 'invoice-details-micro-app',
  InvoiceIngestion = 'invoice-ingestion-micro-app',
  InvoiceSearch = 'invoice-search-micro-app',
  PaymentBatchCreation = 'payment-batch-creation-micro-app',
  PaymentBatchApproval = 'payment-batch-approval-micro-app',
  PaymentBatchHistory = 'payment-batch-history-micro-app',
  PaymentBatchEdit = 'payment-batch-edit-micro-app',
  InvoiceWorkflowList = 'invoice-workflow-list-micro-app',
  InvoiceWorkflowConfig = 'invoice-workflow-config-micro-app',
  PaymentHistory = 'payment-history-micro-app',
  PayableHistory = 'payable-history-micro-app',
  InvoiceRequests = 'invoice-requests-micro-app',
}
